import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-canvas font-sans text-ink" data-id="element-0" data-mp="2wip5x1c7ng4e">
      <Hero data-id="element-1" data-mp="28tmfb3zlmcxr" />
      <main data-id="element-2" data-mp="28te3lff7pdo5">
        <TestimonialsSection data-id="element-3" data-mp="28suu8n3mnxlq" />
        <ProblemSection data-id="element-4" data-mp="28s2xh8yanttv" />
        <VolumesSection data-id="element-5" data-mp="23vuo6c6s2uum" />
        <BonusesSection data-id="element-6" data-mp="23u9vyt7xrnzx" />
        <OfferSection data-id="element-7" data-mp="23v2sz2h3ez4v" />
        <GuaranteeSection data-id="element-8" data-mp="23ti5fwt74ggi" />
        <FaqSection data-id="element-9" data-mp="3ikh5c1uvgeva" />
        <FinalCtaSection data-id="element-10" data-mp="3ij64oawq3n8e" />
      </main>
      <Footer data-id="element-11" data-mp="3ii4su47vuwpm" />
      <StickyCta data-id="element-12" data-mp="3mlj6wpc9h30f" />
    </div>;
}